import React, { useRef } from "react";
import Barcode from "react-barcode";
import "./BarcodeModal.css";
import { currency } from "../../App";

const BarcodeModal = ({ product, onClose }) => {
  const printRef = useRef();

  const offerPrice = (
    product.old_price - (product.old_price * product.new_price) / 100
  ).toFixed(2);

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head>
          <title>Barcode - ${product.name}</title>
          <style>
            body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; min-height: 100vh; margin: 0; background: #fff; }
            .barcode-print-wrapper { text-align: center; padding: 20px; border: 1px solid #ddd; border-radius: 8px; }
            .barcode-print-name { font-size: 14px; font-weight: bold; margin-bottom: 6px; color: #333; }
            .barcode-print-price { font-size: 20px; font-weight: bold; color: #574DC0; margin-top: 8px; }
            .barcode-print-id { font-size: 11px; color: #888; margin-top: 4px; }
          </style>
        </head>
        <body>${printContents}</body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  return (
    <div className="barcode-overlay" onClick={onClose}>
      <div className="barcode-modal" onClick={(e) => e.stopPropagation()}>
        <button className="barcode-close-btn" onClick={onClose}>×</button>
        <h3 className="barcode-modal-title">Product Barcode</h3>

        <div className="barcode-print-wrapper" ref={printRef}>
          <div className="barcode-print-name">{product.name}</div>
          <Barcode
            value={product.unique_id}
            width={1.8}
            height={70}
            fontSize={13}
            displayValue={true}
            background="#ffffff"
            lineColor="#000000"
          />
          <div className="barcode-print-price">
            Price: {currency}{offerPrice}
          </div>
          <div className="barcode-print-id">ID: {product.unique_id}</div>
        </div>

        <button className="barcode-print-btn" onClick={handlePrint}>
          Print Barcode
        </button>
      </div>
    </div>
  );
};

export default BarcodeModal;
